import { render } from "./MortalityRegister.vue?vue&type=template&id=1cfd234d&scoped=true"
import script from "./MortalityRegister.vue?vue&type=script&lang=js"
export * from "./MortalityRegister.vue?vue&type=script&lang=js"

import "./MortalityRegister.vue?vue&type=style&index=0&id=1cfd234d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfd234d"]])

export default __exports__